import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import AnnouncementApiService from '../../../services/superadmin/AnnouncementApiService';

const STORAGE_KEY = 'platform_announcement_seen';

// Verifica se o comunicado já foi dispensado hoje pelo usuário
const wasSeenToday = (announcementId) => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const seen = JSON.parse(raw);
        const today = new Date().toISOString().slice(0, 10);
        return seen[announcementId] === today;
    } catch {
        return false;
    }
};

const markAsSeen = (announcementId) => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const seen = raw ? JSON.parse(raw) : {};
        const today = new Date().toISOString().slice(0, 10);
        seen[announcementId] = today;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(seen));
    } catch {}
};

const PlatformAnnouncementModal = () => {
    const [announcement, setAnnouncement] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        AnnouncementApiService.findActive()
            .then(resp => {
                if (resp.status === 204 || !resp.data) return;
                const item = resp.data;

                if (wasSeenToday(item.id)) return;

                setAnnouncement(item);
                setShow(true);

                if (item.imageUrl) {
                    AnnouncementApiService.downloadImage(item.id)
                        .then(imgResp => {
                            const blob = new Blob([imgResp.data]);
                            setImageUrl(URL.createObjectURL(blob));
                        })
                        .catch(() => {});
                }
            })
            .catch(() => {});
    }, []);

    const handleClose = () => {
        if (announcement) markAsSeen(announcement.id);
        setShow(false);
    };

    if (!announcement) return null;

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="platform-announcement-modal">
            <Modal.Header className="border-0 pb-0">
                <button
                    type="button"
                    className="btn-close ms-auto"
                    aria-label="Fechar"
                    onClick={handleClose}
                />
            </Modal.Header>

            <Modal.Body className="p-0">
                {imageUrl && (
                    <div className="announcement-image-wrap">
                        <img
                            src={imageUrl}
                            alt={announcement.title}
                            className="announcement-image"
                        />
                    </div>
                )}

                <div className="announcement-content">
                    <div className="announcement-badge">
                        <i className="fa-solid fa-bullhorn me-2" />
                        Comunicado da Plataforma
                    </div>

                    <h4 className="announcement-title">{announcement.title}</h4>

                    {announcement.body && (
                        <p className="announcement-body">{announcement.body}</p>
                    )}

                    {announcement.linkUrl && (
                        <a
                            href={announcement.linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary announcement-link-btn"
                        >
                            {announcement.linkLabel || 'Saiba mais'}
                            <i className="fa-solid fa-arrow-right ms-2" />
                        </a>
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer className="border-0 pt-0 announcement-footer">
                <Button variant="light" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PlatformAnnouncementModal;
